import { useContext, useState } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
const cachePromise: any = {};
import { getPermission, getPermission2 } from "@/api/user";
import { getCommonReplys } from "@/api/chat";
import { IPermissions } from "@/types/common";
import { FocusSDK as focusSDK } from "@/utils";
import { ApplyAuthorResourceToConfig } from "@/utils/envConfig";
import { uniqBy, debounce } from "lodash";

const globalDataInitFun = async ({
  setQuickReplyInfo, // 更新全局信息方法
  setPermissions,
  setGlobalDataInitFlag,
  quickReplyVersion, // 需要的参数
  contextGlobalDataInitFlag = {
    permissions: false,
    quickReplys: false
  } // 全局信息初始化标志
}: any) => {
  let globalDataInitFlag = contextGlobalDataInitFlag;
  console.log("globalDataInitFlag--", globalDataInitFlag);
  const result = await GlobalPermissionsFun({
    setPermissions,
    contextGlobalDataInitFlag,
    setGlobalDataInitFlag
  });
  globalDataInitFlag = result.globalDataInitFlag;
  await GlobalQuickReplysFun({
    setQuickReplyInfo,
    quickReplyVersion,
    setGlobalDataInitFlag,
    contextGlobalDataInitFlag: globalDataInitFlag
  });
  return {
    globalDataInitFlag
  };
};

const GlobalPermissionsFun = async ({
  setPermissions,
  setGlobalDataInitFlag,
  contextGlobalDataInitFlag = {
    permissions: false,
    quickReplys: false
  }
}: any) => {
  let globalDataInitFlag = contextGlobalDataInitFlag;

  if (!globalDataInitFlag.permissions) {
    if (!cachePromise.permissionsPromise) {
      cachePromise.permissionsPromise = getPermission();
    }
    if (!cachePromise.permissionsPromise2) {
      cachePromise.permissionsPromise2 = getPermission2([
        "audioVideo.jdVideo", // 音视频.单聊、群聊和个人详情页中用户优先使用京东视频会议
        "eventTracking.startUploading" // 埋点.埋点启动上传
      ]);
    }
    let res: any;
    let permissionsFlag = false;
    let res2: any;
    try {
      // // todo后面再优化并行写文件的问题
      // res = await cachePromise.permissionsPromise;
      // res2 = await cachePromise.permissionsPromise2;
      [res, res2] = await Promise.all([
        cachePromise.permissionsPromise,
        cachePromise.permissionsPromise2
      ]);
      // token 失效网关直接返回{errCode,errMsg}
      if (res?.errorMsg || res2?.errorMsg) {
        permissionsFlag = false;
      } else {
        permissionsFlag = true;
      }
    } catch (e) {
      permissionsFlag = false;
    }
    cachePromise.permissionsPromise = null;
    cachePromise.permissionsPromise2 = null;
    // 两个接口获取权限去重（为什么两个获取权限的接口 问孟凡宇）
    const permissionData = uniqBy([...(res || []), ...(res2 || [])], "code");
    setPermissions(permissionData || []);
    globalDataInitFlag = {
      ...globalDataInitFlag,
      ...{
        permissions: permissionsFlag
      }
    };
    setGlobalDataInitFlag(globalDataInitFlag);
    // 依据权限进行config配置
    debounce(() => {
      focusSDK.printLog("打印getPermission：", permissionData);
    }, 300)();
    ApplyAuthorResourceToConfig(permissionData || []);
  }
  return {
    globalDataInitFlag
  };
};

const GlobalQuickReplysFun = async ({
  setQuickReplyInfo,
  quickReplyVersion,
  setGlobalDataInitFlag,
  contextGlobalDataInitFlag = {
    permissions: false,
    quickReplys: false
  }
}: any) => {
  let globalDataInitFlag = contextGlobalDataInitFlag;
  if (!globalDataInitFlag.quickReplys) {
    if (!cachePromise.quickReplysPromise) {
      cachePromise.quickReplysPromise = getCommonReplys({
        version: quickReplyVersion
      });
    }
    let quickReplysFlag = false;
    const [result, err] = await cachePromise.quickReplysPromise;
    if (result) {
      setQuickReplyInfo({
        quickReplyVersion: result?.version,
        quickReplys: result?.commonReplyList
      });
      quickReplysFlag = true;
    }
    cachePromise.quickReplysPromise = null;
    globalDataInitFlag = {
      ...globalDataInitFlag,
      ...{
        quickReplys: quickReplysFlag
      }
    };
    setGlobalDataInitFlag(globalDataInitFlag);
  }
  return {
    globalDataInitFlag
  };
};


export { GlobalPermissionsFun, GlobalQuickReplysFun, globalDataInitFun };

export default globalDataInitFun;
